import { render } from "./TyndaleBibleDictionaryArticlesWidget.vue?vue&type=template&id=1f6b611c&scoped=true"
import script from "./TyndaleBibleDictionaryArticlesWidget.vue?vue&type=script&lang=js"
export * from "./TyndaleBibleDictionaryArticlesWidget.vue?vue&type=script&lang=js"

import "./TyndaleBibleDictionaryArticlesWidget.vue?vue&type=style&index=0&id=1f6b611c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6b611c"]])

export default __exports__